import { IProjectType } from '@app/models/project-type.model';

export interface State {
    types: IProjectType[];
    isLoading: boolean;
    selectedType: IProjectType;
    isSelectedTypeLoading: boolean;
}

export const initializeProjectTypesState = (): State => {
    return {
        types: [],
        isLoading: false,
        selectedType: null,
        isSelectedTypeLoading: false,
    };
};
